module.exports = __webpack_public_path__ + "static/idmagic-bdbcd6cf775a14d3b75521c97efbcb41.jpg";